// extracted by mini-css-extract-plugin
var _1 = "GateStatusBlock_gray__OycDk";
var _2 = "GateStatusBlock_green__3f92T";
var _3 = "GateStatusBlock_red__gCiK5";
var _4 = "GateStatusBlock_status__EEk14";
var _5 = "GateStatusBlock_yellow__dbkFa";
export { _1 as "gray", _2 as "green", _3 as "red", _4 as "status", _5 as "yellow" }
